import { SelectedAccountUser } from '../../../../../generated';
import type { TypePolicies } from '../../../../../utils/types/TypePolicies';
import { readEntityCacheFragmentById } from '../../utils/typePolicyUtils';

export const typePolicies: TypePolicies = {
  Query: {
    fields: {
      selectedAccountUsers: {
        read: (_existing, { cache, args }) =>
          args.accountUserIds.map((id: any) =>
            readEntityCacheFragmentById({
              cache,
              fragment: SelectedAccountUser,
              fragmentName: 'SelectedAccountUser',
              selector: {
                id,
                __typename: 'AccountUser',
              },
            })
          ),
      },
    },
  },
};
